import script from "./SettingIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__